<template>
  <a-dropdown
    v-bind="attrs"
    :overlay-class-name="`${overlayClassName} ${bem.b('menu-wrapper')}`"
    :class="bem.b()"
  >
    <slot />
    <template #overlay>
      <slot v-if="$slots.overlay" name="overlay" />
      <a-menu v-else>
        <RecursiveMenu
          :items="props.dropdownItems"
          @claim-selected="handleMenuItemClick"
        />
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'
import type { DropdownItem } from './dropdown'
import { dropdownEmits, dropdownProps } from './dropdown'
import RecursiveMenu from './recursive-menu.vue'

defineOptions({ name: 'LlDropdown' })

const props = defineProps(dropdownProps)

const emits = defineEmits(dropdownEmits)

const bem = createNamespace('dropdown')

const attrs = useAttrs()

// 定义处理菜单项点击的方法
const handleMenuItemClick = (item: DropdownItem) => {
  if (!item.disabled) {
    emits('claimSelected', item)
  }
}
</script>
